import './App.css';
import ButtonToTop from './components/ButtonToTop';
import Header from './components/Header';
import PriceList from './components/PriceList';
import Gallery from './components/Gallery';
import OfficeRules from './components/OfficeRules';
import Contacts from './components/Contacts';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <ButtonToTop className="button-to-top" id="home"/>
      <Header />
      <PriceList />
      <Gallery />         
      <Contacts />
      <OfficeRules />
      <Footer /> 
    </div>
  );
}

export default App;
